module.exports = __webpack_public_path__ + "img/price-promise-left.8a47d9e.svg";